import Layout from "@quint/components/layout";
import { Awards, LuxuryHero, OnChainDraw } from "@quint/features/luxury";
import { Image, cn } from "@quint/ui";
import { useHeaderPadding } from "@quint/utils/hooks";
import HeroBg from "public/images/luxury/luxury-hero-bg.png";

const LuxuryPools = () => {
  const headerPadding = useHeaderPadding();

  return (
    <Layout includeHeaderPadding={false}>
      <div className="relative mt-[-200px] flex w-full justify-center md:top-0 md:mt-0">
        <div className="relative flex w-full justify-center overflow-hidden">
          <Image
            src={HeroBg}
            alt="Luxury lights"
            quality={100}
            placeholder="blur"
            priority
            className="min-w-[2000px]"
          />
        </div>

        <div className="dark:luxury-hero-dark-gradient z-2 absolute inset-0 hidden dark:block" />
        <div className={cn("z-3 r absolute inset-0", headerPadding)}>
          <div className="x-padding relative flex h-full w-full justify-center">
            <LuxuryHero />
          </div>
        </div>
      </div>
      <div className="y-padding x-padding">
        <Awards />
        <OnChainDraw />
      </div>
    </Layout>
  );
};

export default LuxuryPools;
